import { makeStyles } from "@material-ui/core/styles";

const useStyle = makeStyles(( theme ) => ({
  actionContainer: {
    marginLeft: 40,
    backgroundColor: theme.palette.background.default,
    borderRadius: 5,
    borderBottomLeftRadius: 0,
    width: "max-content",
    position: "relative",
  },
  color: {
    width: 34,
    height: 52,
    backgroundColor: theme.palette.background.default,
    position: "absolute",
    bottom: -52,
    left: 0,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
  }
}));

export default useStyle;